import PresidentImg from '../assets/officer_imgs/Roxana.JPG';
import VPExternalImg from '../assets/officer_imgs/Aila.jpg';
import VPInternalImg from '../assets/officer_imgs/Cameryn.jpg';

import TreasurerImg from '../assets/officer_imgs/Annie.jpg';
import EventCoordImg from '../assets/officer_imgs/Yasmin.JPG';

import AcademicImg from '../assets/officer_imgs/Thy.jpg';
import TechDevImg1 from '../assets/officer_imgs/Esha.jpg';

import ComingSoon from '../assets/officer_imgs/coming_soon.png';

const Officers = [
  {
    name: 'Roxana Pourfarzaneh',
    position: 'President',
    image: PresidentImg,
    year: '4th Year',
    major: 'Mechanical Engineering',
    fact: 'I’m a big Harry Potter fan ',
    college: 'Eighth',
  },
  {
    name: 'Aila Jahromi',
    position: 'VP External',
    image: VPExternalImg,
    year: '3rd Year',
    major: 'Computer Science',
    fact: 'I was an extra for a show',
    college: 'Eighth',
  },
  {
    name: 'Cameryn Mugol',
    position: 'VP Internal',
    image: VPInternalImg,
    year: '3rd Year',
    major: 'Computer Engineering',
    fact: 'I can solve a rubik\'s cube',
    college: 'Sixth',
  },
  {
    name: 'Annie Qian',
    position: 'Treasurer',
    image: TreasurerImg,
    year: '3rd Year',
    major: 'Chemical Engineering',
    fact: 'I got my first name legally changed',
    college: 'Warren',
  },
  {
    name: 'Yasmin Kabir',
    position: 'Event Coordinator',
    image: EventCoordImg,
    year: '4th Year',
    major: 'Math-CS',
    fact: 'My longest BeReal streak was 550+ days',
    college: 'Warren',
  },
  {
    name: 'Jhynelle Dulay',
    position: 'Secretary',
    image: ComingSoon,
    year: '4th Year',
    major: 'Structural Engineering',
    fact: '',
    college: 'Marshall',
  },
  {
    name: 'Thy Trang',
    position: 'Academic Chair',
    image: AcademicImg,
    year: '3rd Year',
    major: 'Mechanical Engineering',
    fact: 'I\'m double jointed!',
    college: 'Muir',
  },
  {
    name: 'Esha Rami',
    position: 'Technical Development Co-Chair',
    image: TechDevImg1,
    year: '4th Year',
    major: 'Electrical Engineering',
    fact: 'I love to swim!',
    college: 'Sixth',
  },
  {
    name: 'Trescia Loo',
    position: 'Technical Development Co-Chair',
    image: ComingSoon,
    year: '2nd Year',
    major: 'Mechanical Engineering',
    fact: '',
    college: 'Warren',
  },
  {
    name: 'Lauren Peabody',
    position: 'Outreach Co-Chair',
    image: ComingSoon,
    year: '2nd Year',
    major: 'Computer Science',
    fact: '',
    college: 'Revelle',
  },
  {
    name: 'Louvie Davina',
    position: 'Outreach Co-Chair',
    image: ComingSoon,
    year: '2nd Year',
    major: 'Chemical Engineering',
    fact: '',
    college: 'Seventh',
  },
  {
    name: 'Jessica Kendrick',
    position: 'EDGE Co-Chair',
    image: ComingSoon,
    year: '2nd Year',
    major: 'Chemical Engineering',
    fact: '',
    college: 'Eighth',
  },
  {
    name: 'Mia Keely',
    position: 'EDGE Co-Chair',
    image: ComingSoon,
    year: '3rd Year',
    major: 'Structural Engineering',
    fact: '',
    college: 'Seventh',
  },
  {
    name: 'Chloe Gonzalez',
    position: 'Social Chair',
    image: ComingSoon,
    year: 'Third Year',
    major: 'Structural Engineering',
    fact: '',
    college: 'Marshall',
  },
  {
    name: 'Claire Kim',
    position: 'Graphic Design Chair',
    image: ComingSoon,
    year: '4th Year',
    major: 'Mechanical Engineering',
    fact: '',
    college: 'Warren',
  },
  {
    name: 'Olivia Barrios',
    position: 'Marketing Chair',
    image: ComingSoon,
    year: '3rd Year',
    major: 'Structural Engineering',
    fact: '',
    college: 'Sixth',
  },
];

export default Officers;
